import * as Yup from 'yup';

export const ValidationSchema = Yup.object({
    password: Yup.string().required('Password required'),
    matchingPassword: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords do not match').required('Confirm password required'),
    role: Yup.object().nullable().required('Role required'),
    firstName: Yup.string(),
    lastName: Yup.string(),
    email: Yup.string().email('Please enter a valid email').required('Email required'),
})

export const ValidationSchemaChangePsw = Yup.object({
    password: Yup.string().required('Password required'),
    matchingPassword: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords do not match').required('Confirm password required'),
})

export const ValidationSchemaEmail = Yup.object({
    email: Yup.string().email('Please enter a valid email').required('Email required'),
})

export const ValidationSchemaRole = Yup.object({
    role: Yup.object().required('Role required'),
})

export const ValidationSchemaEnable = Yup.object({
    //  enabled: Yup.object().required('Oobbligatorio'),
})

export const ValidationSchemaConfirm = Yup.object({
    confirmed: Yup.boolean().required('Obbligatorio'),
})
